export default function BankTransferIcon({ className }) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <g clipPath="url(#clip0_bank_transfer)">
        <path
          d="M37.0308 39.4179H38.1925C38.8672 39.4179 39.4141 38.8709 39.4141 38.1963V38.1948C39.4141 37.5202 38.8672 36.9732 38.1925 36.9732H19.6338C18.9591 36.9732 18.4121 37.5202 18.4121 38.1948V38.1963C18.4121 38.8709 18.9591 39.4179 19.6338 39.4179H34.6911M23.4613 36.9731H20.907C20.2743 36.9731 19.7614 36.4602 19.7614 35.8275V35.8262C19.7614 35.1934 20.2743 34.6805 20.907 34.6805H23.4613C24.0941 34.6805 24.607 35.1934 24.607 35.8262V35.8275C24.6069 36.4602 24.094 36.9731 23.4613 36.9731ZM36.9192 27.359H34.3649C33.7322 27.359 33.2193 26.8461 33.2193 26.2134V26.212C33.2193 25.5793 33.7322 25.0664 34.3649 25.0664H36.9192C37.552 25.0664 38.0648 25.5793 38.0648 26.212V26.2134C38.0648 26.846 37.552 27.359 36.9192 27.359ZM36.9192 36.9731H34.3649C33.7322 36.9731 33.2193 36.4602 33.2193 35.8275V35.8262C33.2193 35.1934 33.7322 34.6805 34.3649 34.6805H36.9192C37.552 34.6805 38.0648 35.1934 38.0648 35.8262V35.8275C38.0648 36.4602 37.552 36.9731 36.9192 36.9731Z"
          stroke="#61D03B"
          strokeWidth="0.673828"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.4205 29.3896V34.6806H20.9473V30.1408M27.6357 25.0664H30.19C30.8227 25.0664 31.3356 25.5793 31.3356 26.212V26.2134C31.3356 26.8461 30.8227 27.359 30.19 27.359H27.6357C27.1315 27.359 26.7034 27.0332 26.5502 26.5807M27.6762 27.359H30.1495V34.6806H27.6762V27.359ZM34.4052 27.359H36.8785V34.6806H34.4052V27.359Z"
          stroke="#61D03B"
          strokeWidth="0.673828"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.822 18.7267L28.039 18.0043C28.3035 17.8473 28.6054 17.7644 28.913 17.7644C29.2206 17.7644 29.5225 17.8473 29.787 18.0043L38.9934 23.4695C39.742 23.9138 39.4269 25.062 38.5564 25.062H27.2966M12.2406 22.2343H1.80758C1.13289 22.2343 0.585938 21.6873 0.585938 21.0127V21.0113C0.585938 20.3366 1.13289 19.7896 1.80758 19.7896H12.6583M30.1902 36.9687H27.6359C27.0031 36.9687 26.4902 36.4558 26.4902 35.8231V35.8217C26.4902 35.189 27.0031 34.6761 27.6359 34.6761H30.1902C30.8229 34.6761 31.3358 35.189 31.3358 35.8217V35.8231C31.3358 36.4558 30.8229 36.9687 30.1902 36.9687ZM5.63516 10.1754H3.08086C2.44813 10.1754 1.93523 9.6625 1.93523 9.02977V9.02844C1.93523 8.3957 2.44813 7.88281 3.08086 7.88281H5.63516C6.26789 7.88281 6.78078 8.3957 6.78078 9.02844V9.02977C6.78078 9.6625 6.26781 10.1754 5.63516 10.1754ZM5.63516 19.7895H3.08086C2.44813 19.7895 1.93523 19.2766 1.93523 18.6426C1.93523 18.0098 2.44813 17.497 3.08086 17.497H5.63516C6.26789 17.497 6.78078 18.0098 6.78078 18.6426V18.6439C6.78078 19.2766 6.26781 19.7895 5.63516 19.7895ZM19.0931 10.1754H16.5388C15.9061 10.1754 15.3932 9.6625 15.3932 9.02977V9.02844C15.3932 8.3957 15.9061 7.88281 16.5388 7.88281H19.0931C19.7259 7.88281 20.2388 8.3957 20.2388 9.02844V9.02977C20.2387 9.6625 19.7258 10.1754 19.0931 10.1754Z"
          stroke="#61D03B"
          strokeWidth="0.673828"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5791 15.4577V10.1754H19.0523V14.7196M3.12109 10.1754H5.59438V17.497H3.12109V10.1754ZM9.85008 10.1754H12.3234V17.497H9.85008V10.1754ZM12.3639 10.1754H9.80961C9.17688 10.1754 8.66398 9.6625 8.66398 9.02977V9.02844C8.66398 8.3957 9.17688 7.88281 9.80961 7.88281H12.3639C12.9966 7.88281 13.5095 8.3957 13.5095 9.02844V9.02977C13.5095 9.6625 12.9966 10.1754 12.3639 10.1754Z"
          stroke="#61D03B"
          strokeWidth="0.673828"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3641 19.7902H9.80982C9.17709 19.7902 8.6642 19.2773 8.6642 18.6446V18.6432C8.6642 18.0105 9.17709 17.4976 9.80982 17.4976H12.3641C12.8662 17.4976 13.2928 17.8206 13.4476 18.27M5.36193 3.70551L1.00654 6.29098C0.258026 6.73536 0.573104 7.88348 1.44357 7.88348H20.7304C21.6008 7.88348 21.9159 6.73536 21.1674 6.29098L11.961 0.825824C11.6965 0.668803 11.3946 0.585938 11.087 0.585938C10.7794 0.585938 10.4775 0.668803 10.2129 0.825824L7.34834 2.52637M25.1597 7.11996C30.6073 7.11996 35.0236 11.5361 35.0236 16.9839"
          stroke="#61D03B"
          strokeWidth="0.673828"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.6805 15.2227L35.055 17.1421L33.1355 15.5167M14.8405 37.7248C9.39281 37.7248 4.97656 33.3087 4.97656 27.8609"
          stroke="#61D03B"
          strokeWidth="0.673828"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.31934 29.6226L4.9448 27.7031L6.86426 29.3285"
          stroke="#61D03B"
          strokeWidth="0.673828"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.9996 30.1794C24.285 30.1794 27.759 26.7053 27.759 22.4198C27.759 18.1343 24.285 14.6602 19.9996 14.6602C15.7142 14.6602 12.2402 18.1343 12.2402 22.4198C12.2402 26.7053 15.7142 30.1794 19.9996 30.1794Z"
          stroke="#61D03B"
          strokeWidth="0.673828"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.9999 27.7345C22.936 27.7345 25.3163 25.3543 25.3163 22.418C25.3163 19.4818 22.936 17.1016 19.9999 17.1016C17.0638 17.1016 14.6836 19.4818 14.6836 22.418C14.6836 25.3543 17.0638 27.7345 19.9999 27.7345Z"
          stroke="#61D03B"
          strokeWidth="0.673828"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.9544 20.3116C20.9544 20.3116 20.4114 19.8106 19.5743 20.0628C19.0643 20.2164 18.7146 20.8335 18.8769 21.351C19.0711 21.9701 19.9626 22.2108 20.4964 22.3995C21.8577 22.8806 21.3545 24.8096 19.9698 24.8096C19.1546 24.8096 18.7021 24.4684 18.7021 24.4684M19.9698 24.8095V25.5103M19.9698 19.3438V19.9939"
          stroke="#61D03B"
          strokeWidth="0.673828"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_bank_transfer">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
